var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBscLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z",
    fill: "#EDBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10441 5.54562L9.71025 7.15176C9.76801 7.20953 9.86169 7.20953 9.91937 7.15176L10.7658 6.30515C10.8236 6.24741 10.8236 6.15378 10.7658 6.09604L8.10433 3.43396C8.04665 3.37618 7.95295 3.37618 7.89521 3.43396L5.23471 6.09507C5.17697 6.15281 5.17697 6.24644 5.23471 6.30419L6.08114 7.15079C6.13888 7.20856 6.23255 7.20856 6.29029 7.15079L7.89521 5.54562C7.95303 5.48783 8.04665 5.48783 8.10441 5.54562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27941 7.05112L3.43296 7.89776C3.37521 7.95549 3.37521 8.04911 3.43296 8.10687L4.27934 8.95351C4.33708 9.01127 4.43076 9.01127 4.4885 8.95351L5.33496 8.10687C5.3927 8.04911 5.3927 7.95546 5.33496 7.89772L4.48853 7.05115C4.43083 6.99337 4.3372 6.99337 4.27941 7.05112Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1058 12.5659L10.7677 9.9033C10.8255 9.84554 10.8255 9.75186 10.7676 9.6941L9.92076 8.84794C9.863 8.79026 9.7694 8.79026 9.71164 8.84802L8.1058 10.4541C8.04804 10.5119 7.95436 10.5119 7.89662 10.4541L6.29156 8.84882C6.23385 8.79114 6.14032 8.79106 6.08255 8.84866L5.23487 9.69418C5.17698 9.75194 5.17691 9.84562 5.23472 9.90346L7.89662 12.5658C7.9544 12.6235 8.04804 12.6235 8.1058 12.5659Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5109 7.05112L10.6644 7.89775C10.6067 7.9555 10.6067 8.04916 10.6644 8.10684L11.5108 8.95348C11.5686 9.01124 11.6623 9.01124 11.72 8.95348L12.5664 8.10684C12.6242 8.04908 12.6242 7.95546 12.5664 7.89772L11.72 7.05112C11.6623 6.99338 11.5687 6.99338 11.5109 7.05112Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96622 7.89429L8.10374 7.03162C8.04598 6.97384 7.95232 6.97384 7.89457 7.03162L7.03208 7.89429C6.97433 7.95203 6.97433 8.04568 7.03208 8.10344L7.89457 8.96616C7.95232 9.02392 8.04598 9.02392 8.10374 8.96616L8.96622 8.10344C9.02398 8.0456 9.02398 7.95203 8.96622 7.89429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscLogo);
export default __webpack_public_path__ + "static/media/bsc-logo.552962d6bae10a7c0ea44b1923c94775.svg";
export { ForwardRef as ReactComponent };